 
<template>
    <div class="wrapper">
      <div class="model" v-show="model" @click="model = false">
        <div class="model-show">
          <img :src="modelSrc" alt="">
        </div>
      </div>
      <div class="content-a">
        <div class="show-info">
          <div class="test">
            <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.outputSize"
                :outputType="option.outputType"
                :info="option.info"
                :canScale="option.canScale"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :fixedBox="option.fixedBox"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :centerBox="option.centerBox"
                :infoTrue="option.infoTrue"
                :full="option.full"
                :enlarge="option.enlarge"
                :mode="option.mode"
            ></vueCropper>
          </div>
          <!-- <label class="btn" for="upload2">上传</label>
          <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
                 accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
          <button @click="finish()" class="btn">裁剪</button>
          <button @click="downLoad()" class="btn">下载</button>
          <button @click="ok()" class="btn">确定</button>
          <i class="el-icon-refresh-left" @click="rotateLeft"></i>
          <i class="el-icon-refresh-right"  @click="rotateLeft"></i> -->
          <div class="el-image-viewer__btn el-image-viewer__actions">
            <div class="el-image-viewer__actions__inner">
              <!-- <i class="el-icon-zoom-out"
              @click="handleActions('zoomOut')"></i>
            <i class="el-icon-zoom-in"
              @click="handleActions('zoomIn')"></i> -->
              <i class="el-icon-refresh-left"
                @click="rotateLeft()"></i>
              <i class="el-icon-refresh-right"
                @click="rotateRight()"></i>
                <i class="el-icon-crop"
                  @click="finish()"></i>
                <i class="el-icon-circle-check"
                  @click="ok()"></i>
              </div>
            </div>
          </div>
      </div>
   
    </div>
  </template>
   
  <script>
  import {VueCropper} from 'vue-cropper'
  import { shopcertifyUpload } from '@/api/examination'
  import { imgUpload } from '@/api/user'
  import { Loading } from 'element-ui';
  import _ from 'lodash'
  const loadingOptions = { fullscreen: true ,text:'上传文件...',background:'rgba(0,0,0,0.7)'}
  export default {
    components: {
      VueCropper,
    },
    props: {
        imgUrl:{
            type:String,
            default:()=> {
                return ''
            }
        }
    },
    data() {
      return {
        model: false,
        modelSrc: '',
        crap: false,
        previews: {},
        form: {
          head: ''
        },
        option: {
          img:  "", // 裁剪图片的地址 url 地址, base64, blob
          outputSize: 1, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式 jpeg, png, webp
          info: true, // 裁剪框的大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          // autoCropWidth: '60vh', // 默认生成截图框宽度
          // autoCropHeight: '60vh', // 默认生成截图框高度
          fixedBox: false, // 固定截图框大小 不允许改变
          fixed: false, // 是否开启截图框宽高固定比例
          fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
          canMove: true, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          full: true, // 是否输出原图比例的截图
          enlarge: '1', // 图片根据截图框输出比例倍数
          mode: 'contain' // 图片默认渲染方式 contain , cover, 100px, 100% auto
        },
        downImg: '#'
      }
    },
    created() {
      this.init(this.option)
    },
    watch:{
      imgUrl:{
        immediate:true,
        handler: function (val) {
        if (val) {
          this.init(this.option)
        }else{
          this.option.img = ''
        }
      },
      }
    },
    methods: {
         // 上传
         uploadAction:_.throttle(function(file){

          let loadingInstance = Loading.service(loadingOptions)
          let _this = this
          let formData = new FormData()
          formData.append("file", file, new Date()+'.jpeg' )
          // formData.append("type", 'jpeg')
          formData.append("requestId", '123')
          try {
            shopcertifyUpload(formData).then((res) => {
              loadingInstance.close()
              if (res.data && res.data.certityImage) {
                _this.$emit('editImageSuccess',this.imgUrl,res.data.certityImage)
              }
            })
            
          } catch (error) {
            loadingInstance.close()
          }
         },2000),
         handleActions(e){
          console.log(this.$refs.cropper);
          
          if (e == 'zoomOut') {
            this.$refs.cropper.zoom(0.1);
          } else if (e == 'zoomIn'){
            this.$refs.cropper.zoom(-0.1);
          }
         },
        rotateLeft () {
            this.$refs.cropper.rotateLeft()
        },
        rotateRight () {
            // this.$refs.cropper.rotateLeft()
            this.$refs.cropper.rotate=this.$refs.cropper.rotate+90/90;
        },
        
      //初始化
      init(obj) {
        const url = this.imgUrl
        if (url) {
            let _this = this
            this.setAvatarBase64(url, function (res) {
                _this.option.img = res
            })
        }
        // if (obj.img) {
        //   this.option.img = obj.img
        // }
        //裁剪生成图片的质量
        if (obj.outputSize) {
          this.option.outputSize = obj.outputSize
        } else {
          this.option.outputSize = 1
        }
        //裁剪生成图片的格式
        if (obj.outputType) {
          this.option.outputType = obj.outputType
        } else {
          this.option.outputType = 'jpeg'
        }
        //裁剪框的大小信息
        if (obj.info) {
          this.option.info = obj.info
        } else {
          this.option.info = true
        }
        //图片是否允许滚轮缩放
        if (obj.canScale) {
          this.option.canScale = obj.canScale
        } else {
          this.option.canScale = true
        }
        //是否默认生成截图框
        if (obj.autoCrop) {
          this.option.autoCrop = obj.autoCrop
        } else {
          this.option.autoCrop = true
        }
        //默认生成截图框宽度
        // if (obj.autoCropWidth) {
        //   this.option.autoCropWidth = obj.autoCropWidth
        // } else {
        //   this.option.autoCropWidth = 800
        // }
        //默认生成截图框高度
        // if (obj.autoCropHeight) {
        //   this.option.autoCropHeight = obj.autoCropHeight
        // } else {
        //   this.option.autoCropHeight = 800
        // }
        //固定截图框大小 不允许改变
        if (obj.fixedBox) {
          this.option.fixedBox = obj.fixedBox
        } else {
          this.option.fixedBox = false
        }
        //是否开启截图框宽高固定比例
        if (obj.fixed) {
          this.option.fixed = obj.fixed
        } else {
          this.option.fixed = false
        }
        //截图框的宽高比例
        if (obj.fixedNumber) {
          this.option.fixedNumber = obj.fixedNumber
        } else {
          this.option.fixedNumber = [this.option.autoCropWidth, this.option.autoCropHeight]
        }
        //上传图片是否可以移动
        if (obj.canMove) {
          this.option.canMove = obj.canMove
        } else {
          this.option.canMove = true
        }
        //截图框能否拖动
        if (obj.canMoveBox) {
          this.option.canMoveBox = obj.canMoveBox
        } else {
          this.option.canMoveBox = true
        }
        //上传图片按照原始比例渲染
        if (obj.original) {
          this.option.original = obj.original
        } else {
          this.option.original = false
        }
        //截图框是否被限制在图片里面
        if (obj.centerBox) {
          this.option.centerBox = obj.centerBox
        } else {
          this.option.centerBox = true
        }
        //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        if (obj.infoTrue) {
          this.option.infoTrue = obj.infoTrue
        } else {
          this.option.infoTrue = true
        }
        //是否输出原图比例的截图
        if (obj.full) {
          this.option.full = obj.full
        } else {
          this.option.full = true
        }
        //图片根据截图框输出比例倍数
        if (obj.enlarge) {
          this.option.enlarge = obj.enlarge
        } else {
          this.option.enlarge = '1'
        }
        //图片默认渲染方式
        if (obj.mode) {
          this.option.mode = obj.mode
        } else {
          this.option.mode = 'contain'
        }
        if (obj.success) {
          this.success = obj.success
        } else {
          this.success = () => {
          }
        }
      },
      //裁剪
      finish() {
        this.$refs.cropper.getCropData((data) => {
          this.modelSrc = data
          this.model = false;
          //裁剪后的图片显示
          this.option.img = this.modelSrc;
        })
      },
      //下载
      downLoad() {
        if (this.modelSrc == '') {
          console.log('请先选择图片！')
          return
        }
        let url = this.modelSrc
        fetch(url).then(res => res.blob()).then(blob => {//将链接字符地址转换成blob地址
          const aLink = document.createElement('a')
          aLink.href = URL.createObjectURL(blob)
          aLink.download = Date.now() + '.jpg'
          document.body.appendChild(aLink)
          aLink.click()
          aLink.remove()
        })
      },
      ok() {
        let _this = this
        this.$refs.cropper.getCropBlob(data => {
          // 这里data数据为Blob类型，blobToDataURI方法转换成base64
          _this.uploadAction(data)
          // this.blobToDataURI(data, function (res) {
          //   console.log('base64格式：', res)
          // })
        })
      },
      //上传图片
      uploadImg(e, num) {
        this.option.img = ''
        var file = e.target.files[0]
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
          alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
          return false
        }
        var reader = new FileReader()
        reader.onload = (e) => {
          let data = e.target.result
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.option.img = data
          } else if (num === 2) {
            this.option.img = data
          }
        }
        // 转化为blob
        reader.readAsArrayBuffer(file)
      
      },
      //url转base64
      blobToDataURI(blob, callback) {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
          callback(e.target.result);
        }
      },
       // 设置需要展示的图片  base64
    setAvatarBase64(src, callback) {
        let _this = this
        let image = new Image()
        // 处理缓存
        image.src = src + '?v=' + Math.random()
        // 支持跨域图片
        image.crossOrigin = '*'
        image.onload = function() {
            let base64 = _this.transBase64FromImage(image)
            callback && callback(base64)
        }
    },
    // 将网络图片转换成base64格式
    transBase64FromImage(image) {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        // 可选其他值 image/jpeg
        return canvas.toDataURL('image/jpeg')
        }

    },
  }
  </script>
  <style scoped>
  * {
    margin: 0;
    padding: 0;
  }
   
  .content-a {
    margin: auto;
    width:80vw;
    height: 80vh;
    /* margin-bottom: 100px; */
  }
   
  .test-button {
    display: flex;
    flex-wrap: wrap;
  }
   
  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all .2s ease;
    text-decoration: none;
    user-select: none;
  }
   
  .des {
    line-height: 30px;
  }
   
  code.language-html {
    padding: 10px 20px;
    margin: 10px 0px;
    display: block;
    background-color: #333;
    color: #fff;
    overflow-x: auto;
    font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo, Lucida, Sans, Type, Writer, Ubuntu, Mono;
    border-radius: 5px;
    white-space: pre;
  }
   
  .show-info {
    margin-bottom: 50px;
  }
   
  .show-info h2 {
    line-height: 50px;
  }
   
  .test {
    height: 80vh;
  }
   
  .model {
    position: fixed;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }
   
  .model-show {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }
   
  .model img {
    display: block;
    margin: auto;
    max-width: 80%;
    user-select: none;
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
  }
   
  .c-item {
    display: block;
    padding: 10px 0;
    user-select: none;
  }
   
  @keyframes slide {
    0% {
      background-position: 0 0;
    }
   
    100% {
      background-position: -100% 0;
    }
  }
   
  @media screen and (max-width: 1000px) {
    .content-a {
      max-width: 90%;
      margin: auto;
    }
   
    .test {
      height: 400px;
    }
  }
  </style>